import { render, staticRenderFns } from "./TemplateAccount.vue?vue&type=template&id=88690dce"
import script from "./TemplateAccount.vue?vue&type=script&lang=js"
export * from "./TemplateAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports